import { isSavedAsEmpty } from "../emptyText.utils";

// False and "No" are answers; 0 is not, as no spec here (mileage, discard, quarts, CCA, torque) is ever really 0.
export const hasSpecValue = (value: unknown): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === "boolean") return true;
  if (typeof value === "number") return Number.isFinite(value) && value !== 0;
  if (typeof value === "string") {
    const text = value.trim();
    return !!text && !isSavedAsEmpty(text) && !/^0+(\.0*)?$/.test(text);
  }
  if (Array.isArray(value)) return value.some(hasSpecValue);
  return true;
};
